import React from 'react';
import moment from "moment";
import Axios from "axios";
import 'moment/locale/fr'
import {useState, useEffect} from 'react';
import './style.css';
import './descrStyle.css';

function Descriptions() {

  const [themeList, setThemeList] = useState([]);
  const [atelList, setAtelList] = useState([]);

  const [atelColors, setAtelColors] = useState([]);

  const [themeSelected, setThemeSelected] = useState();

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    Axios.get('http://localhost:3001/readthemes').then((response) => {
      setThemeList(response.data);
    });

    Axios.get('http://localhost:3001/readatel').then((response) => {
      setAtelList(response.data);
    });
  }, []);



  const onChangeFilter = (e) => {
    setThemeSelected(e.target.value);
  }

  useEffect(() => {
    if(loading){putColors()};
  }, [loading]);

  const putColors = () => {
    var listColors = [];
    atelList.forEach((atl) => {
      themeList.forEach((tl) => {
        if(atl.atelierTheme == tl.themeName){
          listColors.push({name : atl.atelierName, color : tl.themeColour, description : atl.atelierDescription, theme : atl.atelierTheme});
        }
      })
    })
    console.log(listColors);
    setAtelColors(listColors);
  }

  setLoading(true);

 
  return (
        <div className="contDescr">

            <h2>Découvre notre offre de service !</h2>

            <label for="pet-select">Choisir une thematique :</label>

            <select onChange={onChangeFilter}>
                <option value="">-- Tous --</option>
               {themeList.map((list) => {
                  return (
                    <option style={{"backgroundColor" : `${list.themeColour}`}} value={list.themeName}> {list.themeName}</option>
                  );
                    })
            }
            </select>

            {themeSelected ? 

            <div>
                {atelColors.map((atelier) => {
                    return (
                      themeSelected == atelier.theme &&
                      <li className='atelier'>
                        <b id='descrName'>{atelier.name}</b>
                        <p style={{"textAlign" : "justify"}}>{atelier.description}</p>
                      </li>
                    );
                    })
                }
            </div>

              :

              <div>
                <h3>Tous nos ateliers : ({atelColors.length} ateliers au total)</h3>
              <ul>
              {atelColors.map((atelier) => {
                  return (
                    <li className='atelier'>
                      <b id='descrName'>{atelier.name}</b>
                      <p style={{"textAlign" : "justify"}}>{atelier.description}</p>
                    </li>
                  );
                    })
              }
                
              </ul>
            </div>


            
          }

        </div>
  );
}

export default Descriptions;
